import React, { useState, useEffect, useContext, useRef } from "react";
import { useDispatch } from "react-redux";
import {
  G4ContainerCustomerExperience,
  G4FormCustomerExperience,
  G4CustomerExperienceImgDiv,
  G4CustomerExperienceImg,
  G4TextAreaCustomerExperience,
  G4ButtonCustomerExperience,
  G4TextAriaLabel,
  G4CenteredDiv,
  G4QuestionTag,
} from "./components/styled";
import "./components/SurveyRating.css";
import { nextPage } from "../../../../store/page/actions";
import SurveyService from "../../service";
import FlexRating from "./components/FlexRating";
import MultipleSelectChips from "./components/MultipleSelectChips";

const END = "End";

const SurveyRating = ({ questionMain, pendingSurveyId, config, active }) => {
  const dispatch = useDispatch();
  // const [optionTags, setOptionTags] = useState(null);
  // const [questionTag, setQuestionTag] = useState("");
  const [rate, setRate] = useState(0);
  // const [selectedTags, setSelectedTags] = useState([]);
  // const [observation, setObservation] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const submitLockRef = useRef(false);

  useEffect(() => {

    if(!active){
      dispatch(nextPage(END));
      return;
    }
    let aux = false;
    //setSelectedTags([]);

    // questionMain.options.forEach((el) => {
    //   if (el["rate"] === rate) {
    //     let arrayTag = [];
    //     el["tags"] &&
    //       el["tags"].forEach((tag) => {
    //         arrayTag.push({ label: tag.name, value: tag });
    //       });
    //     setOptionTags(arrayTag);
    //     setQuestionTag(el.question_tag);
    //     aux = true;
    //   }
    // });

    // if (rate === null || aux === false) {
    //   setQuestionTag(null);
    // }
  }, [active, dispatch, questionMain.options, rate]);

    useEffect(() => {
    submitLockRef.current = false;
    setIsSubmitting(false);
    setIsSubmitted(false);
    setRate(0);
  }, [pendingSurveyId]);

  const npsSubmit = async (event) => {
    event.preventDefault();
    if (isSubmitted || isSubmitting || rate < 1) {
      return;
    }

    setIsSubmitting(true);


    try {
      console.log("Enviando pesquisa com:", {
        pendingSurveyId,
        rate
      });
      await SurveyService.sendInquiry(pendingSurveyId, rate);
      setIsSubmitted(true);
      dispatch(nextPage(END));
    } catch (err) {
      console.error(
        "Error ao enviar pesquisa:",
        err.response?.data?.message || err.message || "Erro desconhecido"
      );
      submitLockRef.current = false;
    } finally {
      setIsSubmitting(false);
    }
  };

  // const handleMessageChange = (event) => {
  //   setObservation(event.target.value);
  // };

  return (
    <G4ContainerCustomerExperience>
      <G4CustomerExperienceImgDiv>
        <G4CustomerExperienceImg alt="logo" src={config.logoChat} />
      </G4CustomerExperienceImgDiv>

      <G4FormCustomerExperience>
        <G4CenteredDiv>
          <h4>{questionMain.message}</h4>
        </G4CenteredDiv>

        <FlexRating
          setRate={setRate}
          rate={rate}
          type={questionMain.type}
        />

        {/* <G4QuestionTag>
          {optionTags && optionTags.length > 0 && <h5>{questionTag}</h5>}
        </G4QuestionTag> */}
        {/* <div>
          {optionTags && (
            <MultipleSelectChips
              label=""
              value={selectedTags}
              setValue={setSelectedTags}
              options={optionTags}
            />
          )}
        </div> */}

        {/* <G4TextAriaLabel htmlFor="textId">
          <h4>Deseja adicionar algum comentário?</h4>
        </G4TextAriaLabel>
        <G4TextAreaCustomerExperience
          id="textId"
          name="text"
          rows="4"
          cols="40"
          value={observation}
          onChange={handleMessageChange}
          placeholder="Observação..."
        /> */}
        <G4ButtonCustomerExperience
          onClick={npsSubmit}
          color={config.color}
          disabled={submitLockRef.current || isSubmitted || isSubmitting || rate < 1}
          className={isSubmitting ? "loading" : ""}
        >
          {isSubmitting ? "Enviando..." : "Enviar"}
        </G4ButtonCustomerExperience>
      </G4FormCustomerExperience>
    </G4ContainerCustomerExperience>
  );
};

export default SurveyRating;
